import type { Task } from "@rumble-it/common-lib/types/models/Task.interface";
import type { User } from "@rumble-it/common-lib/types/models/User.interface";

const systemUser = {
  firstName: "Systeem",
  lastName: "",
} as User;

const robertGuliker = {
  firstName: "Robert",
  lastName: "Guliker",
} as User;

/**
 * Mock auto-generated tasks simulating the automated document reminder workflow.
 * The timeline tells a story: documents requested -> reminders sent -> human action needed.
 */
export const autoGeneratedTasks: Task[] = [
  {
    id: "auto-task-1",
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    description: "Schadeformulier opvragen bij bestuurder",
    note: "Automatisch verstuurd per e-mail",
    vehicle: null,
    dossier: null,
    assignee: systemUser,
    reporter: systemUser,
    isCompleted: true,
    status: "completed",
    priority: "normal",
  },
  {
    id: "auto-task-2",
    createdAt: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    description: "Schadefoto's opvragen bij bestuurder",
    note: "Automatisch verstuurd per e-mail",
    vehicle: null,
    dossier: null,
    assignee: systemUser,
    reporter: systemUser,
    isCompleted: true,
    status: "completed",
    priority: "normal",
  },
  {
    id: "auto-task-3",
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    description: "Herinnering schadeformulier versturen",
    note: "Geen reactie na 3 dagen — automatische herinnering verstuurd",
    vehicle: null,
    dossier: null,
    assignee: systemUser,
    reporter: systemUser,
    isCompleted: true,
    status: "completed",
    priority: "normal",
  },
  {
    id: "auto-task-4",
    createdAt: new Date(Date.now() - 4 * 24 * 60 * 60 * 1000).toISOString(),
    description: "Herinnering schadefoto's versturen",
    note: "Geen reactie na 3 dagen — automatische herinnering verstuurd",
    vehicle: null,
    dossier: null,
    assignee: systemUser,
    reporter: systemUser,
    isCompleted: true,
    status: "completed",
    priority: "normal",
  },
  {
    id: "auto-task-5",
    createdAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    description: "Bestuurder bellen — geen reactie op herinneringen",
    note: "Actie vereist: neem telefonisch contact op met de bestuurder",
    vehicle: null,
    dossier: null,
    assignee: robertGuliker,
    reporter: systemUser,
    isCompleted: false,
    status: "open",
    priority: "urgent",
  },
];
